import {useSelector} from 'react-redux';

import {selectIsDarkMode} from '@/state/selectors/uwm';

const useTipFillColor = (): string => {
    const isDarkMode = useSelector(selectIsDarkMode);

    return isDarkMode ? 'var(--app-orion-2)' : 'var(--app-light-silver)';
};

export default useTipFillColor;
